import MigrationSignupSection from "../Components/MigrationSignupSection";
import Title from "../Common/Title";
import {Typography} from "@sgi/gravity/Typography";
import {Flex} from "@chakra-ui/react";
import {useState} from "react";

export enum MigrationAction {
  None,
  SendCode,
  PromptChangeEmail,
  ChangeEmail
}

interface MigrationProps {
  defaultMigrationAction: MigrationAction;
}

export default function Migration(props: MigrationProps) {
  const [migrationAction, setMigrationAction] = useState<MigrationAction>(props.defaultMigrationAction);

  const setMigrationActionHandler = (newMigrationAction: MigrationAction): void => {
    setMigrationAction(newMigrationAction);
  }

  const getTitle = (): string => {
    switch (migrationAction) {
      case MigrationAction.SendCode:
        return "Confirm your details";
      case MigrationAction.ChangeEmail:
        return "Change email address";
      case MigrationAction.PromptChangeEmail:
      default:
        return "Time to update your account!";
    }
  }

  const renderDescription = () => {
    switch (migrationAction) {
      case MigrationAction.SendCode:
        return <>
          Use the verification code we sent you to confirm your account.
        </>;
      case MigrationAction.ChangeEmail:
        return <>Enter your new email address for your MySGI account.</>;
      case MigrationAction.PromptChangeEmail:
      default:
        return <>
          To start, enter and verify <b>your own</b> email address.
          <br/>
          You'll use this to sign in to MySGI. It can't be used by another MySGI account.
        </>;
    }
  }

  return (
    <Flex direction="column" maxW={544} padding={38} mx="auto">
      <Title text={getTitle()} data-testid="title-test"/>
      <Typography variant="body" mb={8}>
        {renderDescription()}
      </Typography>
      <MigrationSignupSection migrationAction={migrationAction} setMigrationAction={setMigrationActionHandler}/>
    </Flex>
  );
}
